import "./Design/Dashboard.css"
import { useEffect, useRef, useState } from "react";
import "./Design/Dashboard.css"
import { Button, Table, TableCell, TableHead } from "@mui/material";
import businessPpt from "../Learning/Business Plan Growniverse PPT._20250418_224941_0000.pdf";
import keyToSuccess from "../Learning/Growniverse Key to Success by R.S.O..pdf";
import AffiliateLink from "./AffiliateLink";

const Tools = () => {
    const [growniverseId, setGrowniverseId] = useState("");
    const runOnce = useRef(false);
    useEffect(() => {
        if (runOnce.current === false) {
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            setGrowniverseId(userProfile.growniverseId);
            runOnce.current = true;
        }
    }, [runOnce]);
    const downloadPdf = (type:number) => {
        const link = document.createElement('a');
        link.href = type === 1 ? businessPpt : keyToSuccess;
        link.target = '_blank';
        link.click();
    }
    return <>
        <>
            <AffiliateLink />
            <section className="headerBackgroundReverse" style={{ padding: "30px", background: "" }}>
                <h3 style={{ textAlign: "center", color: "white", background: "black", padding: "10px", borderRadius: "8px" }}>Key To Success</h3>
                <div style={{ background: "white", borderRadius: "10px", padding: "10px" }}>
                    <Table>
                        <TableHead>
                            <TableCell align="center">Key To Success</TableCell>
                            <TableCell align="center"><Button onClick={()=>{downloadPdf(2)}} style={{ gap: "5px" }}>View <i className="fas fa-eye"></i>
                            </Button></TableCell>
                        </TableHead>
                    </Table>
                </div>
            </section>
            <section className="headerBackgroundReverse" style={{ padding: "30px", background: "" }}>
                <h3 style={{ textAlign: "center", color: "white", background: "black", padding: "10px", borderRadius: "8px" }}>Business Plan</h3>
                <div style={{ background: "white", borderRadius: "10px", padding: "10px" }}>
                    <Table>
                        <TableHead>
                            <TableCell align="center">Business Plan</TableCell>
                            <TableCell align="center"><Button onClick={()=>{downloadPdf(1)}} style={{ gap: "5px" }}>View <i className="fas fa-eye"></i>
                            </Button></TableCell>
                        </TableHead>
                    </Table>
                </div>
            </section>
        </>
    </>
};

export default Tools;